import React from "react";
import moment from 'moment'
import { Link, useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import MUIDataTable from "mui-datatables";
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import { createMuiTheme, MuiThemeProvider,withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress'
import Status from 'components/Self/Status.js';
import Hover from 'components/Self/Hover.js';
import Status2 from 'components/Self/PreStatus.js';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import EditIcon from '@material-ui/icons/Edit';
import axios from 'axios';
import { Button, Container, Row, Col, Modal, FormGroup, } from "reactstrap";
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';


const getMuiTheme = () =>
    createMuiTheme({
        overrides: {
            MUIDataTable: {
                root: {
                    backgroundColor: '#000',
                },
                paper: {
                    backgroundColor: '#000',
                    borderRadius: '10px',
                },
            },
            MuiToolbar: {
                root: {
                    color: "f4f5f7"
                },
            },
            MuiTableCell: {
                head: {
                    backgroundColor: 'purple',
                },
                root: {
                    borderBottom: 'none',
                }
            },
            MuiSvgIcon: {
                root: {
                    backgroundColor: '',
                    color: 'white !important',
                    '&:hover': {
                        color: "#a5a7bc"
                    }
                }
            },
            MuiInputBase: {
                input: {
                    borderBottom: '1px solid white',
                    '&:hover': {
                        // borderBottom: '1px solid #ff0000 !important',
                        outline: '0 !important',
                    }
                }
            },
            MuiInput: {
                formControl: {
                    color: 'white',
                    borderBottom: '1px solid white',
                    '&:hover': {
                        borderBottom: '1px solid #fff !important',
                        outline: '0 !important',
                    }
                }
            },
            MUIDataTableFilter: {
                root: {
                    backgroundColor: '#000',
                    color: 'white'
                },
                title: {
                    color: 'white'
                },
            },
            MUIDataTableToolbarSelect: {
                root: {
                    backgroundColor: '#000',
                    color: 'white'
                },
                title: {
                    color: 'white'
                },
            },
            MuiTypography: {
                root: {
                    color: 'white !important'
                },
            },
            MUIDataTableViewCol: {
                root: {
                    backgroundColor: '#000'
                },
                title: {
                    color: 'white'
                },
                label: {
                    color: 'white'
                }
            },
            MuiTablePagination: {
                selectIcon: {
                    color: 'white',
                }
            },
            MuiIconButton: {
                root: {
                    backgroundColor: '',
                    color: 'yellow',
                    '&:hover': {
                        color: "#a5a7bc"
                    }
                },
                label: {
                    backgroundColor: '',
                }
            },
            MUIDataTableBodyRow: {
                root: {
                    backgroundColor: 'transparent',
                    borderBottom: '1px solid #8898aa'
                }
            },
            MuiTableRow: {
                root:
                {
                    '&$hover:hover':
                        { backgroundColor: '#1e1e1e' }
                }
            },
            MUIDataTableBodyCell: {
                root: {
                    color: "#f4f5f7",
                    // width: "50px"
                    // minWidth: '100px !important',
                    // backgroundColor: 'pink',
                }
            },
            MUIDataTableHeadRow: {
                root: {
                    backgroundColor: "transparent",
                    height: '5px',
                    borderBottom: '1px solid #8898aa',
                },
            },
            MUIDataTableHeadCell: {
                data: {
                    color: "white",
                },
                fixedHeader: {
                    backgroundColor: "transparent",
                    color: "white"
                },
                sortActive: {
                    backgroundColor: '',
                    color: '#c5c7dc'
                }
            },
            MuiHeader: {
                backgroundColor: "green"
            },
            MuiTableFooter: {
                root: {
                    '& .MuiToolbar-root': {
                        color: '#f4f5f7',
                    },
                },
            },
            MUIDataTableToolbar: {
                root: {
                    backgroundColor: '',
                    color: "#f4f5f7",
                },
                icon: {
                    color: "#f4f5f7",
                    '&:hover': {
                        color: "#a5a7bc"
                    }
                },
            },
            MUIDataTableSelectCell: {
                headerCell: {
                    backgroundColor: 'transparent',
                },
            },
        },
    });

const getMuiTheme2 = () =>
    createMuiTheme({
        overrides: {
            MUIDataTableToolbar: {
                root: {
                    backgroundColor: '',
                    color: "#32325d",
                },
                icon: {
                    color: "#32325d",
                    '&:hover': {
                        color: "#32325d"
                    }
                },
            },
            MuiSvgIcon: {
                color: "#32325d !important",
            }
        },
    });

const Negotiations = (props) => {
    const location = useLocation();
    // const history = useHistory();


    const useStyles = makeStyles((theme) =>
        createStyles({
            avatar2: {
                height: '95%',
                width: '87%',
                marginLeft: '5px'
            },
            paper: {
                width: '300px',
                height: '90px',
                backgroundColor: props.theme === 'white' ? '' : props.theme === 'dark' ? 'black' : 'purlpe',
                zIndex: 90,
                // boxShadow: 'none',
                border: '1px solid #E8E8E8'
            },
        }),
    );
    const classes = useStyles()
    const CTooltip = withStyles({ tooltip: { fontSize: "14px", padding: '7px', } })(Tooltip);
    const [sendingdata, setSendingdata] = React.useState('');
    const [emailsel, setemailsel] = React.useState('Click to Copy Email');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const [delevent, setdelevent] = React.useState(false);
    // const [delpre, setdelpre] = React.useState(false);
    const [loading, setloading] = React.useState(true);
    const [tablename, settablename] = React.useState(false);
    const [tablename2, settablename2] = React.useState(false);
    const [filterset, setfilterset] = React.useState(false);
    const [del, setdel] = React.useState([]);
    const [filtered, setfiltered] = React.useState([]);
    const [filterset2, setfilterset2] = React.useState(false);
    const [filtered2, setfiltered2] = React.useState([]);
    if (location) {
        // console.log('yes location')
        // console.log(location);
        // console.log(location.state);
        if (location.state !== null && location.state !== undefined) {
            if (location.state.token) {
                if (location.state.token === 1) {
                    // console.log(location.state.message);
                    setSendingdata(location.state.message)
                    settt(location.state.type)
                    setOpen(true);
                    location.state.token -= 1;
                }
            }
        }

    }
    else {
        // console.log('nope')
    }

    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleClose2 = (event, reason) => {
        setOpen2(false);
    };
    const handleCloseDelEvent = (event, reason) => {
        setdelevent(false);
    };
    const [responseDatab, setResponseData1] = React.useState([]);
    const [responseDatap, setResponseData2] = React.useState([]);
    // console.log(props.token)
    const fetchData = React.useCallback(() => {
        // console.log('enrtered')
        axios.get(process.env.REACT_APP_DOMAIN+"/events", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                setResponseData1(response.data)
                // console.log(response.data)
                // console.log(responseDatab)
                setloading(false)
                settablename('No Events Found ')
            })
            .catch((error) => {
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true)
                setloading(false)
                settablename('Something went Wrong')
            })
        axios.get(process.env.REACT_APP_DOMAIN+"/preevents", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                setResponseData2(response.data)
                // console.log(response.data)
                // console.log(responseDatab)
                setloading(false)
                settablename2('No Pre Events Found ')
            })
            .catch((error) => {
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true)
                setloading(false)
                settablename2('Something went Wrong')
            })
    }, [props.token])
    React.useEffect(() => {
        fetchData()
        // setInterval(() => {
        //     // console.log('fetching.........')
        //     fetchData();
        // }, 10000)
        document.title = "Dashboard - Depact"
    }, [fetchData])

    const dataBuyer2 = []
    if(responseDatab){
        responseDatab.map(function (responseDatab, index) {
            // console.log(responseDatab.edate)
            var date = moment(responseDatab.date).format('Do MMM YY')
            var tfrom = moment(responseDatab.tfrom, "HH:mm:ss").format("hh:mm A")
            var tto = moment(responseDatab.tto, "HH:mm:ss").format("hh:mm A")
            dataBuyer2.push({
                TID: responseDatab.id, Edit: <Link to={'edit/' + responseDatab.id}><EditIcon className="point" /></Link>, Type: [responseDatab.etype, responseDatab.id],
                Publisher: [responseDatab.by.username, { photo: responseDatab.by.photo, first_name: responseDatab.by.first_name, last_name: responseDatab.by.last_name, email: responseDatab.by.email, is_superuser: responseDatab.by.is_superuser, is_staff: responseDatab.by.is_staff }],
                Title: [responseDatab.title,responseDatab.id],
                Status: [responseDatab.status, responseDatab.id],
                Date: date, Published: responseDatab.pdate, Time: tfrom + ' - ' + tto ,
                Last: responseDatab.edate,
            })
            return (<div></div>)
        })
    }

    const dataBuyer3 = []
    if(responseDatap){
        responseDatap.map(function (responseDatab, index) {
            // console.log(responseDatab.edate)
            var tfrom
            var tto
            var date
            if(responseDatab.tfrom !== null){
                tfrom = moment(responseDatab.tfrom, "HH:mm:ss").format("hh:mm A")
            }
            else{
                tfrom = ''
            }
            if (responseDatab.tto !== null) {
                tto = moment(responseDatab.tto, "HH:mm:ss").format("hh:mm A")
            }
            else {
                tto = ''
            }
            if (responseDatab.date !== null) {
                date = moment(responseDatab.date).format('Do MMM YY')
            }
            else {
                date = ''
            }
            dataBuyer3.push({
                TID: responseDatab.id, Edit: <Link to={'edit/'+responseDatab.id}><EditIcon className="point" /></Link>, Type: [responseDatab.etype, responseDatab.id],
                Publisher: [responseDatab.by.username, { photo: responseDatab.by.photo, first_name: responseDatab.by.first_name, last_name: responseDatab.by.last_name, email: responseDatab.by.email, is_superuser: responseDatab.by.is_superuser, is_staff: responseDatab.by.is_staff}], 
                Description: [responseDatab.description, responseDatab.id],
                Status: [responseDatab.status, responseDatab.id],
                Date: date, Published: responseDatab.pdate, Time: tfrom + ' - ' + tto,
                // Last: edate,
            })
            return (<div></div>)
        })
    }
    
    const columnsBuyer = [{ name: "TID", label: 'TID', options: { filter: true, filterType: 'multiselect', sort: true, } },
    { name: "Title", label: "Title", options: { filter: true, filterType: 'textField', sort: true, customBodyRender: (value) => (<Link to={'event/'+value[1]}><p className={"min-width-300 colbody point underline-hover texts-" + props.theme}> {value[0]} </p></Link>) } },
    { name: "Type", label: "Type", options: { filter: false, sort: true, customBodyRender: (value) => (<Chip label={value[0]} color="secondary" key={value[1]} id={2} />) } },
    { name: "Status", label: "Status", options: { filter: false, sort: true, customBodyRender: (value) => (<Status className="min-width-150" fetch={props.fetch} key={value[0]} prodKey={value[1]} productStat={value[0]} />) } },
    { name: "Date", label: "Date", options: { filter: true, filterType: 'multiselect', sort: false, customBodyRender: (value) => (<p className={"min-width-100 colbody texts-" + props.theme}> {value} </p>) } },
    { name: "Time", label: "Time", options: { filter: true, filterType: 'multiselect', sort: false, customBodyRender: (value) => (<p className={"min-width-200 colbody texts-" + props.theme}> {value} </p>)  } },
    { name: "Publisher", label: "Publisher", options: { filter: true, filterType: 'textField', sort: true, customBodyRender: (value) => (
    
                                                    <Hover placement="top" delay={200} component={(
                                                <Paper className={'bg-greenc ' + classes.paper}>
                                                    <Row className="bg-orangec full-height ml-0 pt-2 pb-2" >
                                                        <Col lg="3" sm="3" xs="3" md="3" className="bg-greenc pl-0 pr-0">
                                                            <Avatar aria-label="recipe" src={value[1].photo} className={classes.avatar2}>
                                                                {value[1].first_name.substring(0,1)}{value[1].last_name.substring(0,1)}
                                                            </Avatar>
                                                        </Col>
                                                        <Col lg="9" sm="9" xs="9" md="9" className="bg-yellowc pl-1">
                                                            <Link to={'profile/' + value[0]}><h3 style={{ fontWeight: 'normal' }} className="point mb-0 bg-redc pl-0">{value[0]}</h3></Link>
                                                            <p style={{ fontSize: '14px' }} className="mt-0 mb-0 bg-redc pl-0">{value[1].first_name} {value[1].last_name}<span className='l-wc'>{value[1].is_superuser ? ' (Super Admin)' : value[1].is_staff ? ' (Faculty)' : ' (Student)'}</span></p>
                                                            <CTooltip arrow title={emailsel} placement='top-end' aria-label="add">
                                                                <p onClick={(e) => { navigator.clipboard.writeText(value[1].email); setemailsel('Copied the Email') }} style={{ fontSize: '14px' }} className="point mt-0 mb-0">{value[1].email}</p>
                                                            </CTooltip>
                                                        </Col>
                                                    </Row></Paper>)}>
            <Link to={'profile/' + value[0]} ><p className={"colbody point min-width-150 underline-hover texts-" + props.theme}> {value[0]} </p></Link>
                                                    </Hover>
                                                    ) } },
    { name: "Published", label: "Published", options: { filter: false, sort: true, customBodyRender: (value) => (<p className={"min-width-100 colbody texts-" + props.theme}> {moment(value).fromNow()} </p>) } },
    { name: "Edit", label: "Edit", options: { filter: false, sort: false, download: false } },
    { name: "Last", label: "Last Edited", options: { filter: false, sort: true, customBodyRender: (value) => (<p className={"min-width-100 colbody texts-" + props.theme}> {moment(value).fromNow()} </p>) } },
    ];

    const columnsBuyer2 = [{ name: "TID", label: 'TID', options: { filter: true, filterType: 'multiselect', sort: true, } },
    // { name: "Edit", label: "Edit", options: { filter: false, sort: false,download: false } },
    { name: "Type", label: "Type", options: { filter: false, sort: true,customBodyRender: (value) => (<Chip label={value[0]} color="secondary" key={value[1]} id={2} />) } },
    { name: "Description", label: "Description", options: { filter: true, filterType: 'textField', sort: true, customBodyRender: (value) => (<p className={"colbody min-width-300 texts-" + props.theme}> {value[0]} </p>) } },
    { name: "Status", label: "Status", options: { filter: false, sort: true, customBodyRender: (value) => (<Status2 fetch={props.fetch} key={value[0]} prodKey={value[1]} productStat={value[0]} />) } },
    { name: "Date", label: "Date", options: { filter: true, filterType: 'multiselect', sort: false, customBodyRender: (value) => (<p className={"min-width-100 colbody texts-" + props.theme}> {value} </p>) } },
    { name: "Time", label: "Time", options: { filter: true, filterType: 'multiselect', sort: false, customBodyRender: (value) => (<p className={"min-width-200 colbody texts-" + props.theme}> {value} </p>) } },
    { name: "Publisher", label: "Publisher", options: { filter: true, filterType: 'textField', sort: true, customBodyRender: (value) => (
    
                                                    <Hover placement="top" delay={200} component={(
                                                <Paper className={'bg-greenc ' + classes.paper}>
                                                    <Row className="bg-orangec full-height ml-0 pt-2 pb-2" >
                                                        <Col lg="3" sm="3" xs="3" md="3" className="bg-greenc pl-0 pr-0">
                                                            <Avatar aria-label="recipe" src={value[1].photo} className={classes.avatar2}>
                                                                {value[1].first_name.substring(0,1)}{value[1].last_name.substring(0,1)}
                                                            </Avatar>
                                                        </Col>
                                                        <Col lg="9" sm="9" xs="9" md="9" className="bg-yellowc pl-1">
                                                            <Link to={'profile/' + value[0]}><h3 style={{ fontWeight: 'normal' }} className="point mb-0 bg-redc pl-0">{value[0]}</h3></Link>
                                                            <p style={{ fontSize: '14px' }} className="mt-0 mb-0 bg-redc pl-0">{value[1].first_name} {value[1].last_name}<span className='l-wc'>{value[1].is_superuser ? ' (Super Admin)' : value[1].is_staff ? ' (Faculty)' : ' (Student)'}</span></p>
                                                            <CTooltip arrow title={emailsel} placement='top-end' aria-label="add">
                                                                <p onClick={(e) => { navigator.clipboard.writeText(value[1].email); setemailsel('Copied the Email') }} style={{ fontSize: '14px' }} className="point mt-0 mb-0">{value[1].email}</p>
                                                            </CTooltip>
                                                        </Col>
                    </Row></Paper>)}>
                <Link to={'profile/' + value[0]} ><p className={"colbody point min-width-150 underline-hover texts-" + props.theme}> {value[0]} </p></Link>
            </Hover>
        )
        }
        },
    { name: "Published", label: "Published", options: { filter: false, sort: true, customBodyRender: (value) => (<p className={"min-width-100 colbody texts-" + props.theme}> {moment(value).fromNow()} </p>) } },
    // { name: "Last", label: "Last Edited", options: { filter: false, sort: true, } },
    ];

    var delx = []

    const optionsBuyer = {
        filterType: 'checkbox',
        responsive: 'standard',
        textLabels: {
            body: {
                noMatch: loading ? <CircularProgress className={"mt-2 bg-yellowx mb-2 textb-" + props.theme} /> : tablename,
            },
        },
        onRowsDelete: (rowsDeleted) => {
            // console.log(rowsDeleted.data)
            setdel([])
            delx = []
            for (var i = 0; i < rowsDeleted.data.length; i++) {
                delx.push(dataBuyer2[rowsDeleted.data[i].index]['TID'])
            }
            // console.log(delx)
            setdel(delx)
            setOpen2(true)
            return false;
        },
        onFilterChange: (changedColumn, filterList, type, changedColumnIndex, displayData) => {
            setfiltered(displayData)
            setfilterset(true)
        },
        // onDownload: (buildHead, buildBody, columns, data) => {
        //     for (var i = 0; i < data.length; i++) {
        //         // console.log(data[i])
        //         // console.log(data[i].data[1])
        //         data[i].data[2] = data[i].data[2][0]
        //         data[i].data[3] = data[i].data[3][0]
        //         data[i].data[4] = data[i].data[4][0]
        //         data[i].data[7] = data[i].data[7][0]
        //     }
        //     return "\uFEFF" + buildHead(columns) + buildBody(data);
        // },
        onDownload: (buildHead, buildBody, columns, data) => {
            if (filterset === true) {
                var filterdata = []
                for (var i = 0; i < data.length; i++) {
                    data[i].data[2] = data[i].data[2][0]
                    data[i].data[3] = data[i].data[3][0]
                    data[i].data[4] = moment(data[i].data[4]).format('Do MMM YY')
                    data[i].data[6] = data[i].data[6][0]
                    data[i].data[7] = moment(data[i].data[7]).fromNow()
                    data[i].data[9] = moment(data[i].data[9]).fromNow()
                }
                console.log(data)
                data.map(function (cur, index) {
                    filtered.map(function (cur2, index) {
                        if (cur.index === cur2.dataIndex) {
                            console.log('yes')
                            filterdata.push(cur)
                        }
                        return(null)
                    })
                    return(null)
                })
                console.log(filterdata)
                return "\uFEFF" + buildHead(columns) + buildBody(filterdata);
            }
            else {
                for (var c = 0; c < data.length; c++) {
                    data[c].data[2] = data[c].data[2][0]
                    data[c].data[3] = data[c].data[3][0]
                    data[c].data[4] = moment(data[c].data[4]).format('Do MMM YY')
                    data[c].data[6] = data[c].data[6][0]
                    data[c].data[7] = moment(data[c].data[7]).fromNow()
                    data[c].data[9] = moment(data[c].data[9]).fromNow()
                }
                console.log(data)
                return "\uFEFF" + buildHead(columns) + buildBody(data);
            }

        },
        downloadOptions: {
            filename: 'events.csv',
            separator: ',',
            filterOpions: {
                useDisplayedColumnsOnly: true,
                useDisplayedRowsOnly: true,
            }
        },
        customSort: (data, colIndex, order, meta) => {
            if (colIndex === 2 || colIndex === 4 || colIndex === 3 || colIndex === 7) {
                // console.log(colIndex)
                return data.sort((a, b) => {
                    return (a.data[colIndex][0]< b.data[colIndex][0] ? -1 : 1) * (order === 'desc' ? 1 : -1);
                });
            }
            else {
                return data.sort((a, b) => {
                    // console.log(a.data[colIndex])
                    return (a.data[colIndex] < b.data[colIndex] ? -1 : 1) * (order === 'desc' ? 1 : -1);
                });
            }
        },
        print: false,
        sortDescFirst: false,
        sortThirdClickReset: false,
        selectableRows: 'none',
    };

    const optionsBuyer2 = {
        filterType: 'checkbox',
        responsive: 'standard',
        textLabels: {
            body: {
                noMatch: loading ? <CircularProgress className={"mt-2 bg-yellowx mb-2 textb-" + props.theme} /> : tablename2,
            },
        },
        onRowsDelete: (rowsDeleted) => {
            // console.log(rowsDeleted.data)
            setdel([])
            delx = []
            for (var i = 0; i < rowsDeleted.data.length; i++) {
                delx.push(dataBuyer2[rowsDeleted.data[i].index]['TID'])
            }
            // console.log(delx)
            setdel(delx)
            setOpen2(true)
            return false;
        },
        onFilterChange: (changedColumn, filterList, type, changedColumnIndex, displayData) => {
            setfiltered2(displayData)
            setfilterset2(true)
        },
        // onDownload: (buildHead, buildBody, columns, data) => {
        //     for (var i = 0; i < data.length; i++) {
        //         // console.log(data[i])
        //         // console.log(data[i].data[1])
        //         data[i].data[2] = data[i].data[2][0]
        //         data[i].data[3] = data[i].data[3][0]
        //         data[i].data[4] = data[i].data[4][0]
        //         data[i].data[7] = data[i].data[7][0]
        //     }
        //     return "\uFEFF" + buildHead(columns) + buildBody(data);
        // },
        onDownload: (buildHead, buildBody, columns, data) => {
            if (filterset2 === true) {
                var filterdata2 = []
                for (var i = 0; i < data.length; i++) {
                    data[i].data[2] = data[i].data[2][0]
                    data[i].data[3] = data[i].data[3][0]
                    data[i].data[4] = moment(data[i].data[4]).format('Do MMM YY')
                    data[i].data[6] = data[i].data[6][0]
                    data[i].data[7] = moment(data[i].data[7]).fromNow()
                }
                console.log(data)
                data.map(function (cur, index) {
                    filtered2.map(function (cur2, index) {
                        if (cur.index === cur2.dataIndex) {
                            console.log('yes')
                            filterdata2.push(cur)
                        }
                        return (null)
                    })
                    return (null)
                })
                console.log(filterdata2)
                return "\uFEFF" + buildHead(columns) + buildBody(filterdata2);
            }
            else {
                for (var c = 0; c < data.length; c++) {
                    data[c].data[2] = data[c].data[2][0]
                    data[c].data[3] = data[c].data[3][0]
                    data[c].data[4] = moment(data[c].data[4]).format('Do MMM YY')
                    data[c].data[6] = data[c].data[6][0]
                    data[c].data[7] = moment(data[c].data[7]).fromNow()
                }
                console.log(data)
                return "\uFEFF" + buildHead(columns) + buildBody(data);
            }

        },
        downloadOptions: {
            filename: 'events.csv',
            separator: ',',
            filterOpions: {
                useDisplayedColumnsOnly: true,
                useDisplayedRowsOnly: true,
            }
        },
        customSort: (data, colIndex, order, meta) => {
            if (colIndex === 2 || colIndex === 4 || colIndex === 3 || colIndex === 7) {
                // console.log(colIndex)
                return data.sort((a, b) => {
                    return (a.data[colIndex][0] < b.data[colIndex][0] ? -1 : 1) * (order === 'desc' ? 1 : -1);
                });
            }
            else {
                return data.sort((a, b) => {
                    // console.log(a.data[colIndex])
                    return (a.data[colIndex] < b.data[colIndex] ? -1 : 1) * (order === 'desc' ? 1 : -1);
                });
            }
        },
        print: false,
        sortDescFirst: false,
        sortThirdClickReset: false,
        selectableRows: 'none',
    };

    const handleDelete = () => {
        // console.log(del)
        // console.log(del.length)

        if ((del.length < 1) || (del === undefined)) {
            setSendingdata('Something went wrong')
            settt('error')
            setOpen(true);
            return 0;
        }
        // console.log(del)
        axios.post(process.env.REACT_APP_DOMAIN+'/deletecontracts', { data: del })
            .then((response) => {
                // console.log(response.data)
                setOpen(true)
                setSendingdata(response.data.message)
                settt(response.data.type)
                setOpen2(false)
                fetchData();
            })
            .catch((error) => {
                // console.log(error)
                setOpen(true)
                setSendingdata('Something went wrong')
                settt('error')
                setOpen2(false)
                fetchData();
            })
    };

    return (
        <>
            <div className="header bg-gradient-bluec pb-8 pt-5 pt-md-8">
                <Container fluid>
                    <div className="header-body">
                    </div>
                </Container>
            </div>
            <Container className="mt--8" fluid>
                <div className="header-body">
                    <Row>
                        <Col lg="12" xl="12" sm="12" xs="12" className="mb-4">
                            <div style={{ height: 'wrap-content', width: '100%' }}>
                                {(props.theme === 'white' ?
                                    <MuiThemeProvider theme={getMuiTheme2()}>
                                    <MUIDataTable
                                        className={"back noshad sbg-"+props.theme}
                                        title={<div className="mt-4 mb-3" style={{ width: '100%', backgroundColor: '' }}><div className="col pl-0">
                                            <h6 className="text-uppercase ls-1 mb-1">
                                                All
                                        </h6>
                                            <h2 className="text-whiteg mb-0">Events</h2>
                                        </div></div>}
                                        data={dataBuyer2}
                                        columns={columnsBuyer}
                                        options={optionsBuyer}
                                        />
                                    </MuiThemeProvider>
                                    :
                                    <MuiThemeProvider theme={getMuiTheme()}>
                                        <MUIDataTable
                                            className={"back cardbg-" + props.theme}
                                            title={<div className="mt-4 mb-3" style={{ width: '100%', backgroundColor: '' }}><div className="col pl-0">
                                                <h6 className="text-uppercase text-light ls-1 mb-1">
                                                    All
                                                </h6>
                                                <h2 className="text-white mb-0">Events</h2>
                                            </div></div>}
                                            data={dataBuyer2}
                                            columns={columnsBuyer}
                                            options={optionsBuyer}
                                        />
                                    </MuiThemeProvider>
                                )}
                            </div>
                        </Col>
                        <Col lg="12" xl="12" sm="12" xs="12" className="mb-9">
                            <div style={{ height: 'wrap-content', width: '100%' }}>
                                {(props.theme === 'white' ?
                                    <MuiThemeProvider theme={getMuiTheme2()}>
                                    <MUIDataTable
                                        className={"back noshad sbg-" + props.theme}
                                        title={<div className="mt-4 mb-3" style={{ width: '100%', backgroundColor: '' }}><div className="col pl-0">
                                            <h6 className="text-uppercase ls-1 mb-1">
                                                All
                                        </h6>
                                            <h2 className="text-whiteg mb-0">Pre-Events</h2>
                                        </div></div>}
                                        data={dataBuyer3}
                                        columns={columnsBuyer2}
                                        options={optionsBuyer2}
                                    />
                                    </MuiThemeProvider>
                                    :
                                    <MuiThemeProvider theme={getMuiTheme()}>
                                        <MUIDataTable
                                            className={"back cardbg-" + props.theme}
                                            title={<div className="mt-4 mb-3" style={{ width: '100%', backgroundColor: '' }}><div className="col pl-0">
                                                <h6 className="text-uppercase text-light ls-1 mb-1">
                                                    All
                                                </h6>
                                                <h2 className="text-white mb-0">Pre-Events</h2>
                                            </div></div>}
                                            data={dataBuyer3}
                                            columns={columnsBuyer2}
                                            options={optionsBuyer2}
                                        />
                                    </MuiThemeProvider>
                                )}
                            </div>
                        </Col>
                        <Modal
                            className="modal-dialog-centered"
                            isOpen={open2}
                            toggle={handleClose2}>
                            <div className="modal-header">
                                <h2 className="modal-title mt-2 mb-0" id="modal-title-default">  Delete Contract </h2>
                                <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={handleClose2}> <span aria-hidden={true}>×</span> </button>

                            </div>
                            <div className="modal-header text-muted mt-0 mb-0">
                                <small>Note : If you delete this contract it will be permanently deleted. This will be notified to all the People invloved in this contract.</small>
                            </div>
                            <Row className="modal-body bg-orangec">
                                <Col lg="6">
                                    <FormGroup>
                                        <label className="form-control-label mt-2" htmlFor="input-bags">Are you Sure ?</label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="modal-footer bg-tealx pt-0">
                                <Button color="inf" data-dismiss="modal" type="button" onClick={handleClose2}> Close </Button>
                                <Button className="ml-auto" color="danger" onClick={handleDelete} outline> Delete </Button>
                            </div>
                        </Modal>
                        <Modal
                            className="modal-dialog-centered"
                            isOpen={delevent}
                            toggle={handleCloseDelEvent}>
                            <div className="modal-header">
                                <h2 className="modal-title mt-2 mb-0" id="modal-title-default">  Delete Events </h2>
                                <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={handleCloseDelEvent}> <span aria-hidden={true}>×</span> </button>

                            </div>
                            <div className="modal-header text-muted mt-0 mb-0">
                                <small>Note : If you delete these events they will be permanently deleted. This will be notified to all the Faculty invloved in these events.</small>
                            </div>
                            <Row className="modal-body bg-orangec">
                                <Col lg="6">
                                    <FormGroup>
                                        <label className="form-control-label mt-2" htmlFor="input-bags">Are you Sure ?</label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="modal-footer bg-tealx pt-0">
                                <Button color="inf" data-dismiss="modal" type="button" onClick={handleCloseDelEvent}> Close </Button>
                                <Button className="ml-auto" color="danger" onClick={handleDelete} outline> Delete </Button>
                            </div>
                        </Modal>
                    </Row>
                </div>
            </Container>
            <Container className="mt-0 mb-8" fluid>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Negotiations);
